export function shippingAddressDefaultsFromGraphQL(address) {
  if (!address) {
    return {
      id: "",
      name: "",
      line1: "",
      line2: "",
      city: "",
      postcode: "",
      country: "",
      phoneNumber: ""
    };
  }
  return {
    id: address.id ?? "",
    name: address.name ?? "",
    line1: address.line1 ?? "",
    line2: address.line2 ?? "",
    city: address.city ?? "",
    postcode: address.postcode ?? "",
    country: address.country?.id ?? "",
    phoneNumber: address.phoneNumber ?? ""
  };
}
